import { Theme, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

function getWindowDimensions(theme: Theme) {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height,
		isMobile: width < theme.breakpoints.values.md,
	};
}

export const useWindowDimensions = () => {
	const theme = useTheme();
	const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions(theme));

	useEffect(() => {
		function handleResize() {
			setWindowDimensions(getWindowDimensions(theme));
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowDimensions;
};
